import React from 'react';
import { renderDebouncedTextField as RenderDebouncedTextField } from 'components/form/field/redux-field';

export default ({ field, label, input, meta, disabled, labelSize, qaId }) => (
  <RenderDebouncedTextField
    label={label}
    input={input}
    meta={meta}
    disabled={disabled}
    labelSize={labelSize}
    qaId={qaId}
    suffix={field.suffix}
    centerInput={field?.centerInput ?? null}
    maxLength={field.maxLength ?? ''}
    validCharacters={field.validCharacters ?? undefined}
  />
);
